import React from 'react';
import { AuthRoles } from "components/auth";

export const EstablishmentsConfig = {
    auth: AuthRoles.admin,
    routes: [
        {
            path: `${process.env.PUBLIC_URL}/establishments`,
            component: React.lazy(() => import('./Establishments'))
        }
    ]
};